import { useMoiaErrorNotification } from '@backoffice-frontend/patterns'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const useMicrophonePermission = () => {
  const { t } = useTranslation()
  const [isMicrophoneEnabled, setIsMicrophoneEnabled] = useState(true)
  const { enqueueMoiaErrorNotification } = useMoiaErrorNotification()

  const notifyAccessDenied = () => {
    enqueueMoiaErrorNotification(t('adFleetMap_microphoneAccessDeniedError'))
  }

  const enableMicrophone = async () => {
    if (!navigator.permissions) {
      enqueueMoiaErrorNotification(
        t('adFleetMap_microphoneAccessNotSupportedError'),
      )
      setIsMicrophoneEnabled(false)
      return
    }

    try {
      const { state: permission } = await navigator.permissions.query({
        name: 'microphone',
      })

      switch (permission) {
        case 'prompt': {
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: true,
          })
          const audioTracks = stream.getAudioTracks()
          if (audioTracks.length === 0) {
            notifyAccessDenied()
          }
          setIsMicrophoneEnabled(audioTracks.length > 0)
          return
        }
        case 'denied': {
          notifyAccessDenied()
          setIsMicrophoneEnabled(false)
          return
        }
        case 'granted': {
          setIsMicrophoneEnabled(true)
          return
        }
      }
    } catch {
      notifyAccessDenied()
      setIsMicrophoneEnabled(false)
    }
  }

  return { isMicrophoneEnabled, enableMicrophone }
}
